import Axios from 'axios';
import { BillItemGroup, BillSettings, BillData } from '@/models/billData';
import { TaxRoundTypes } from '@/enums/taxRoundTypes';
import { BillItemGroupTypes } from '@/enums/billItemGroupTypes';
import { GradeYears } from '@/enums/gradeYears';
import { BillTypes } from '@/enums/billTypes';
import { TaxTypes } from '@/enums/taxTypes';
import { EnabledTypes } from '@/enums/enabledTypes';
import { PaymentStatusTypes } from '@/enums/paymentStatusTypes';
import { BillStatusTypes } from '@/enums/billStatusTypes';
import { Tag } from 'element-ui';
import { BillItemsResponse } from '@/models/billItemResponse';
import { ReadTypes } from '@/enums/readTypes';

interface State {
  billSettings: BillSettings;
  billItemGroups: BillItemGroup[];
  billCondition: {
    perPage: number,
    page: number,
    sort: string,
    enabledType: EnabledTypes,
    billType: BillTypes,
    billStatus: BillStatusTypes | null,
    paymentStatus: PaymentStatusTypes,
    readType: ReadTypes,
    billDateFrom: Date | null,
    billDateTo: Date | null,
    billLimitDateFrom: Date | null,
    billLimitDateTo: Date | null,
    ordinarySchoolId: string | null,
    gradeYear: GradeYears | null,
    tagList: Tag[],
    keyWord: string,
  };
  billDownloadCondition: {
    perPage: number,
    page: number,
    sort: string,
    enabledType: EnabledTypes,
    billType: BillTypes,
    billStatus: BillStatusTypes | null,
    paymentStatus: PaymentStatusTypes,
    readType: ReadTypes,
    billDateFrom: Date | null,
    billDateTo: Date | null,
    billLimitDateFrom: Date | null,
    billLimitDateTo: Date | null,
    ordinarySchoolId: string | null,
    gradeYear: GradeYears | null,
    tagList: Tag[],
    keyWord: string,
  };
  periodicBillCondition: {
    perPage: number,
    page: number,
    sort: string,
    enabledType: EnabledTypes,
    billType: BillTypes,
    ordinarySchoolId: string | null,
    gradeYear: GradeYears | null,
    tagList: Tag[],
    keyWord: string,
  };
  billTemplateCondition: {
    perPage: number,
    page: number,
    sort: string,
    enabledType: EnabledTypes,
    billType: BillTypes,
    paymentStatus: PaymentStatusTypes,
    billDateFrom: Date | null,
    billDateTo: Date | null,
    billLimitDateFrom: Date | null,
    billLimitDateTo: Date | null,
    ordinarySchoolId: string | null,
    gradeYear: GradeYears | null,
    tagList: Tag[],
    keyWord: string,
  };
}
const mapState: State = {
  billSettings: {
    taxType: TaxTypes.External,
    taxRoundType: TaxRoundTypes.HalfUp,
  },
  billItemGroups: [],
  billCondition : {
    perPage: 20,
    page: 1,
    sort: '',
    enabledType: EnabledTypes.Enabled,
    billType: BillTypes.None,
    billStatus: null,
    paymentStatus: PaymentStatusTypes.None,
    readType: ReadTypes.All,
    billDateFrom: null,
    billDateTo: null,
    billLimitDateFrom: null,
    billLimitDateTo: null,
    ordinarySchoolId: null,
    gradeYear: null,
    tagList: [],
    keyWord: '',
  },
  billDownloadCondition : {
    perPage: 20,
    page: 1,
    sort: '',
    enabledType: EnabledTypes.Enabled,
    billType: BillTypes.None,
    billStatus: null,
    paymentStatus: PaymentStatusTypes.None,
    readType: ReadTypes.All,
    billDateFrom: null,
    billDateTo: null,
    billLimitDateFrom: null,
    billLimitDateTo: null,
    ordinarySchoolId: null,
    gradeYear: null,
    tagList: [],
    keyWord: '',
  },
  periodicBillCondition : {
    perPage: 20,
    page: 1,
    sort: '',
    enabledType: EnabledTypes.Enabled,
    billType: BillTypes.None,
    ordinarySchoolId: null,
    gradeYear: null,
    tagList: [],
    keyWord: '',
  },
  billTemplateCondition : {
    perPage: 20,
    page: 1,
    sort: '',
    enabledType: EnabledTypes.Enabled,
    billType: BillTypes.None,
    paymentStatus: PaymentStatusTypes.None,
    billDateFrom: null,
    billDateTo: null,
    billLimitDateFrom: null,
    billLimitDateTo: null,
    ordinarySchoolId: null,
    gradeYear: null,
    tagList: [],
    keyWord: '',
  }
};

const mapActions = {
  async fetchBillSettings({ commit }: any) {
    const response = await Axios.get('/api/bill-settings/bill-calc');
    commit('setBillSettings', response.data);
  },
  async fetchBillItems({ commit }: any) {
    const res = await Axios.get<BillItemsResponse>('/api/bill-items');
    const resData = res.data;

    const billItemGroups = resData.billItemGroups
      .filter((group) => group.billItems.length > 0)
      .map((group) => ({
        groupType: group.billItemGroupType,
        billItems: group.billItems.map((item) => ({
          itemId: item.billItemId,
          itemName: item.itemName,
          nonTaxable: item.nonTaxable,
          gradeYearItems: item.gradeYears.map((gradeYear) => ({
            gradeYear: gradeYear.gradeYear,
            unitPrice: gradeYear.unitPrice,
          })),
        }))
      }));

    commit('setBillItemGroups', billItemGroups);
  }
};

const mapMutations = {
  setBillSettings(state: State, billSettings: BillSettings) {
    state.billSettings = billSettings;
  },
  setBillItemGroups(state: State, billItemGroups: BillItemGroup[]) {
    state.billItemGroups = billItemGroups;
  },
};

export default {
  namespaced: true,
  state: mapState,
  actions: mapActions,
  mutations: mapMutations,
};
